import React from "react";
import TermsConditions from "../components/About/TermsCondition";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const Terms = () => {
  return (
    <div>
      <Navbar />
      <TermsConditions />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default Terms;
